interface Props {
  label: string;
  error?: boolean;
}

// Small centered status line used by view components for loading /
// empty / error states. Kept as its own component to avoid repeating
// the aria + layout boilerplate in every view.
export function InlineStatus({ label, error = false }: Props) {
  return (
    <div
      role={error ? 'alert' : 'status'}
      className={`flex items-center justify-center py-16 text-sm ${
        error ? 'text-danger' : 'text-muted'
      }`}
    >
      {label}
    </div>
  );
}
